<template>
    <div>
        <el-row>
            <el-col>
                <el-row type="flex" justify="center" :gutter="20">
                    <el-col class="text-md-left" :span="24">
                        <el-card style="margin-top: 16px;" shadow="never">
                            <div style="margin-bottom: 10px">
                                <el-row>
                                    <el-col>
                                        <el-form inline>
                                             <el-form-item>
                                                <el-input
                                                    class="search-input"
                                                    v-model="searchText"
                                                    placeholder="ค้นหา ชื่อร้าน"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item label="เลือกวันที่">
                                                <el-date-picker
                                                    v-model="dateSelect"
                                                    type="date"
                                                    placeholder="เลือกวันที่">
                                                    </el-date-picker>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button type="primary" @click="fetchHistoryNotify">ค้นหา</el-button>
                                            </el-form-item>
                                        </el-form>
                                    </el-col>
                                </el-row>
                            </div>
                            <div>
                                <data-tables
                                    :data="histotyList"
                                    style="width: 100%"
                                    class="dataTbHistory notify-courier-header"
                                >
                                    <el-table-column
                                        label="ticketPickupId"
                                        header-align="center"
                                        width="150">
                                        <div class="text-md-left" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            {{scope.row.ticketPickupId}}
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        label="ShopCode"
                                        header-align="left"
                                        width="100">
                                        <div class="text-md-left" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            {{getShopCode(scope.row.srcName)}}
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        label="ชื่อร้าน"
                                        header-align="center"
                                        width="200">
                                        <div class="text-md-left" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            {{getShopName(scope.row.srcName)}}
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        label="ที่อยู่ร้าน"
                                        header-align="center">
                                        <div class="text-md-left" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            {{scope.row.srcDetailAddress}} {{scope.row.srcProvinceName}} {{scope.row.srcDistrictName}} {{scope.row.srcCityName}} {{scope.row.postalCode}}
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        label="จำนวนออเดอร์"
                                        header-align="center"
                                        align="center"
                                        width="150">
                                        <div class="text-md-center" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            {{scope.row.estimateParcelNumber}}
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        label="สถานะ"
                                        header-align="center"
                                        align="center"
                                        width="150">
                                        <div class="text-md-center" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            <b>{{scope.row.stateText}}</b>
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        prop="createdAt"
                                        label="เวลา"
                                        width="130">
                                        <div class="text-md-left" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            {{ scope.row.createdAt * 1000 | dayjs('format', 'HH:mm:ss') }} น.
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        prop="remark"
                                        label="remark"
                                        min-width="130">
                                        <div class="text-md-left" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }">
                                            {{ scope.row.remark }}
                                        </div>
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        prop="createdAt"
                                        label="จัดการ"
                                        width="130">
                                        <div class="text-md-left" slot-scope="scope" :style="{'color': (scope.row.state === 4) ? 'red' : '' }" v-if="scope.row.state !== 4">
                                        <el-button type="danger" @click="cancelNotify(scope.row)" >ยกเลิก</el-button>
                                        </div>
                                    </el-table-column>
                                </data-tables>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <cancel-notify
        :dialogShow="dialogCancelNotify"
        :notifyDetail="notifyCancelDetail"
        @closeModal="dialogCancelNotify = false"
        @closeModalRefresh="fetchHistoryNotify"
        ></cancel-notify>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import cancelNotify from '@/components/Courier/NotiflyCancel'
export default {
    name: 'CancelCourierNotifyTab',
    components: {
        cancelNotify
    },
    data () {
        return {
            shopAllList: [],
            shopAllListCheck: [],
            countOrder: null,
            filtersShop: [
                { prop: 'label', value: '' }
            ],
            dateSelect: new Date(),
            histotyList: [],
            dialogCreateNotify: false,
            dialogCancelNotify: false,
            notifyDetail: {},
            notifyCancelDetail: {},
            pagination: {
                limit: 20,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [20, 50, 100]
            },
            searchText: ''
        }
    },
    created () {
        this.fetchHistoryNotify()
    },
    methods: {
        async notifyCourier (shop) {
            // validate
            if (shop.parcelNumber === null) {
                this.$refs[`parcel-${shop.id}`].focus()
                this.$message({ type: 'warning', message: 'กรุณากรอกจำนวนออเดอร์ที่จะ notify !' })
                return
            }
            let loadingNotify = this.$loading({
                target: '.loadAllShop',
                text: 'กำลังส่งข้อมูล Notify ...'
            })
            try {
                let resShop = await fgApi.shop.getShopByShopID({ shop_id: parseInt(shop.id) })
                console.log(resShop)
                let resCourier = await fgApi.courier.getCourierByUserID({ target_user_id: resShop.data.userId })
                console.log(resCourier)
                let flashAccID = resCourier.data.courierAccounts.filter(courier => courier.courierId === 4)
                if (flashAccID.length === 0) {
                    this.$message.error('ไม่สามารถ notify ได้ ไม่มีข้อมูล courier FLASH !')
                } else {
                    let param = {
                        shopId: shop.id,
                        courierAccountId: flashAccID[0].courierAccountId,
                        parcelNumber: shop.parcelNumber
                    }
                    let resNotify = await fgApi.courier.notifyCourier(param)
                    if (resNotify.success) {
                        this.$message({ type: 'success', message: 'บันทึกข้อมูลเรียบร้อยแล้ว' })
                    } else {
                        this.$message.error(resNotify.message)
                    }
                }
            } catch (error) {
                console.log(error)
                this.$message.error('Oops !, Api is error.')
            }
            loadingNotify.close()
        },
        async fetchHistoryNotify () {
            try {
                let loading = this.$loading({
                    target: '.dataTbHistory',
                    text: 'กำลังโหลดข้อมูล...'
                })
                const params = {
                    date: this.$dayjs(this.dateSelect).format('YYYY-MM-DD'),
                    search: this.searchText
                }
                let resHistory = await fgApi.courier.getNotifyHistory(params)
                console.log(resHistory)
                this.histotyList = resHistory.data
                loading.close()
            } catch (error) {
                this.$message.error(error)
            }
        },
        getShopCode (shopName) {
            shopName = shopName.split('-')
            shopName = shopName[0].split('code')
            return shopName[1]
        },
        getShopName (shopName) {
            shopName = shopName.split('-')
            return shopName[1]
        },
        CreateNotify (val) {
            this.notifyDetail = { ...val }
            this.dialogCreateNotify = !this.dialogCreateNotify
        },
        cancelNotify (val) {
            this.notifyCancelDetail = { ...val }
            this.dialogCancelNotify = !this.dialogCancelNotify
        }
    }
}
</script>

<style lang="scss" scoped>
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-transfer-panel{
    width: 300px;
    height:400px;
}
.el-transfer-panel__list.is-filterable{
    height:300px;
    font-size:16px;
    text-align: left;
}
::v-deep .pagination-bar {
    margin-top: 16px !important;
}
.notify-courier-header {
    ::v-deep th {
        background: #000000;
        color: #FFFFFF !important;
    }
}
</style>
